import Icon from '@ant-design/icons';
import { Button, Col, Row, Space, Steps, StepsProps, Typography } from 'antd';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IReport, useReportId } from '../../../../../hooks/reports';
import { Back } from '../../../../Common/Icon';
import Loading from '../../../../Common/Loading';
import ActivityRow from './activityRow';
import { useGetReportActivities } from '../../../../../hooks/activities';
import { Activity } from '../../../../../types/activities';

const customDot: StepsProps['progressDot'] = (dot) => dot;

const ActivitiesById = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    fetch: getReport,
    data: reportData,
    loading: isGetReportLoading,
  } = useReportId();

  const {
    fetch: getReportActivities,
    data: reportActivitiesData,
    loading: isGetReportActivitiesLoading
  } = useGetReportActivities();

  const reportActivities = (reportActivitiesData?.data ?? []) as Activity[];
  const report = (reportData?.data ?? {}) as IReport;
  const isLoading = isGetReportLoading || isGetReportActivitiesLoading;

  useEffect(() => {
    if (!id) return;

    getReport(undefined, id);
    getReportActivities(undefined, id);
  }, []);

  const steps = reportActivities?.length
    ? [
        {
          status: 'finish' as 'wait' | 'process' | 'finish' | 'error',
          description: (
            <div style={{ paddingTop: '2rem', maxWidth: '230px' }}>
              <ActivityRow activities={reportActivities} />
            </div>
          ),
          className: 'steps',
        },
      ]
    : [
        {
          status: 'wait' as 'wait' | 'process' | 'finish' | 'error',
          className: 'default-class',
          description: <div>No activities found</div>,
        },
      ];

  const handleBack = () => {
    navigate({ pathname: '/reports' });
  };

  return (
    <section>
      <Loading visible={isLoading} absolute />
      <Row>
        <Col span={24}>
          <Space direction="vertical" size={24}>
            <Space size={4}>
              <Button
                type="ghost"
                icon={<Icon component={Back} style={{ fontSize: '1.25em' }} />}
                onClick={handleBack}
              />
              <Typography.Title style={{ marginLeft: '20px' }}>
                Activities for report {report?.name?.toLocaleUpperCase() || '(Unnamed Report)'}
              </Typography.Title>
            </Space>
            <Steps
              style={{ marginLeft: '20px' }}
              progressDot={customDot}
              direction="vertical"
              items={[...(steps || []), { status: 'finish', className: 'd-none' }]}
            />
          </Space>
        </Col>
      </Row>
    </section>
  );
};

export default ActivitiesById;
